import styled from 'styled-components';
import { Nav, NavItem, NavLink } from 'reactstrap';
import { NavLink as RRNavLink } from 'react-router-dom';
import { Link } from 'react-scroll';
import {
  fontStyle,
  fontWeight,
  fontSize,
  bodyColor,
  fontFamily,
  resetLinkStyle,
} from '@whitelabel/helpers/style/type';
import { gray, themeColor } from '@whitelabel/helpers/style/colors';
import { mediaBreakpointUp } from '@whitelabel/helpers/style/grid';
import { ReactComponent as IconChevronUp } from '@whitelabel/media/icons/small/chevron-up.svg';
import { StyledCard } from '@whitelabel/component-library';
import { plainLinkStyle } from '@whitelabel/xcover-shared/helpers/style/utils';

export const StyledSidebarCard = styled(StyledCard)`
  padding: 1rem 0;
  font-size: ${fontSize('base')};

  && {
    margin-bottom: 2rem;
  }
`;

export const StyledSidebarTitle = styled.p`
  margin-bottom: 0.5rem;
  padding: 0 1rem;
  color: ${gray(600)};
  font-size: ${fontSize('sm')};
  font-family: ${fontFamily('serif')};
  text-transform: uppercase;
`;

export const StyledNavItem = styled(NavItem)`
  ${fontStyle('contentMenu')}
  width: 100%;
  padding-top: 0;
  padding-bottom: 0;
  padding-inline-end: 1rem;
  padding-inline-start: 0.75rem;
  border-inline-start: 0.25rem solid transparent;
  transition: all 0.35s ease;

  ${mediaBreakpointUp('lg')`
    &.active {
        border-left-color: ${themeColor('secondary')};
        ${fontStyle('contentMenuActive')}
    }
  `}

  &:not(:last-child) {
    margin-bottom: 1rem;
  }
`;

export const StyledChildNav = styled(Nav).attrs(() => ({ vertical: true }))`
  display: none;
  margin-top: 0.5rem;

  ${mediaBreakpointUp('lg')`
    display: block;
  `}
`;

export const StyledNavLink = styled(NavLink).attrs(() => ({
  tag: Link,
  spy: true,
  smooth: true,
  offset: -16,
  duration: 350,
}))`
  ${resetLinkStyle}
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0;
  color: ${bodyColor};
  cursor: pointer;

  &:hover {
    ${plainLinkStyle}
  }

  ${mediaBreakpointUp('lg')`
  &:not(.active){
      ${fontStyle('contentMenu')}
      font-weight: normal !important;
  }
    .active & {
      ${fontStyle('contentMenuActive')}
    }

    .active ${StyledChildNav} & {
      font-weight: normal;
    }
  `}
`;

export const StyledChevron = styled(IconChevronUp)`
  display: none;
  flex-shrink: 0;
  margin-inline-start: 1rem;
  color: ${gray(600)};
  transition: all 0.35s ease;

  ${mediaBreakpointUp('lg')`
    display: block;

    .active & {
      color: ${gray(700)};
      transform: rotate(-180deg);
    }
  `}
`;

export const StyledChildNavItem = styled(NavItem)`
  padding: 0;

  &:not(:last-child) {
    margin-bottom: 0.5rem;
  }
`;

export const StyledHR = styled.hr`
  display: none;
  margin-top: 0;
  margin-bottom: 0.5rem;
  margin-inline: 1rem;
  border-top-color: ${gray(300)};

  ${mediaBreakpointUp('lg')`
    .active & {
      display: block;
    }
  `}
`;

export const StyledWrapper = styled.div`
  margin: 0 0.75rem;
  margin-top: 1rem;
`;

export const StyledItemDivider = styled.hr`
  color: ${gray(400)};
  margin: 0 auto;
`;

export const StyledIcon = styled.svg.attrs(() => ({ 'aria-hidden': 'true' }))`
  display: block;
  margin-inline-end: 0.5rem;
`;

export const StyledLogoutButton = styled(NavLink).attrs(() => ({ tag: RRNavLink }))`
  ${resetLinkStyle};
  margin-top: 1.25rem;
  margin-bottom: 0;
  margin-inline-end: 0;
  margin-inline-start: 0.2rem;
  padding: 0;
  display: flex;
  align-items: center;
  text-transform: uppercase;
  font-weight: ${fontWeight('black')};
  font-size: ${fontSize('md')};

  &:hover {
    ${plainLinkStyle}
  }
`;
